export const getDatePickerStrings = i18n => ({
  months: [
    i18n.getString(_TL_('January')),
    i18n.getString(_TL_('February')),
    i18n.getString(_TL_('March')),
    i18n.getString(_TL_('April')),
    i18n.getString(_TL_('May')),
    i18n.getString(_TL_('June')),
    i18n.getString(_TL_('July')),
    i18n.getString(_TL_('August')),
    i18n.getString(_TL_('September')),
    i18n.getString(_TL_('October')),
    i18n.getString(_TL_('November')),
    i18n.getString(_TL_('December')),
  ],
  shortMonths: [
    i18n.getString(_TL_('Jan')),
    i18n.getString(_TL_('Feb')),
    i18n.getString(_TL_('Mar')),
    i18n.getString(_TL_('Apr')),
    i18n.getString(_TL_('May')),
    i18n.getString(_TL_('Jun')),
    i18n.getString(_TL_('Jul')),
    i18n.getString(_TL_('Aug')),
    i18n.getString(_TL_('Sep')),
    i18n.getString(_TL_('Oct')),
    i18n.getString(_TL_('Nov')),
    i18n.getString(_TL_('Dec')),
  ],
  days: [
    i18n.getString(_TL_('Sun')),
    i18n.getString(_TL_('Mon')),
    i18n.getString(_TL_('Tue')),
    i18n.getString(_TL_('Wed')),
    i18n.getString(_TL_('Thu')),
    i18n.getString(_TL_('Fri')),
    i18n.getString(_TL_('Sat')),
  ],
  shortDays: [
    i18n.getString(_TL_('S')),
    i18n.getString(_TL_('M')),
    i18n.getString(_TL_('T')),
    i18n.getString(_TL_('W')),
    i18n.getString(_TL_('T')),
    i18n.getString(_TL_('F')),
    i18n.getString(_TL_('S')),
  ],
  goToToday: i18n.getString(_TL_('Go to today')),
  prevMonthAriaLabel: i18n.getString(_TL_('Go to previous month')),
  nextMonthAriaLabel: i18n.getString(_TL_('Go to next month')),
  prevYearAriaLabel: i18n.getString(_TL_('Go to previous year')),
  nextYearAriaLabel: i18n.getString(_TL_('Go to next year')),
  closeButtonAriaLabel: i18n.getString(_TL_('Close date picker')),
  isRequiredErrorMessage: i18n.getString(_TL_('Start date is required.')),
  invalidInputErrorMessage: i18n.getString(_TL_('Invalid date format.')),
});
